const _excluded = ["appendix8"],
  _excluded2 = ["system"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable no-underscore-dangle */

const {
  getContentValue,
  hasContentValue
} = require('@truqc/content-path');
const {
  merge,
  pick
} = require('lodash');
const evaluateSource = require('../lib/evaluateSource');
const {
  flattenCollection
} = require('../lib/common');
const latestStatusFromContent = content => {
  const {
    statusHistory = null
  } = content;
  if (statusHistory === null) {
    return statusHistory;
  }
  const [latestStatusHistory = {}] = Object.values(statusHistory).sort((a, b) => new Date(b._created) - new Date(a._created));
  return latestStatusHistory.status;
};
const getInfo = workItemLocations => flattenCollection(workItemLocations).map(pedigree => {
  const [{
    identifier: workItemIdentifier,
    title: workItemTitle
  } = {
    identifier: 'noWorkItem',
    title: 'No Work Item'
  }, {
    identifier: locationIdentifier,
    title: locationTitle
  } = {
    identifier: 'noLocation',
    title: 'No Location'
  }] = pedigree;
  return {
    identifier: [workItemIdentifier, locationIdentifier].join('_'),
    path: ['', 'appendix8', 'workItemLocation', workItemIdentifier, 'children', locationIdentifier].join('/'),
    // path: path.join('/', 'appendix8', 'workItemLocation', workItemIdentifier,
    //  'children', locationIdentifier),
    title: [workItemTitle, locationTitle].join(' / ')
  };
});
const getReports = async (workItemLocations, sortOrder, reportTypes, nativeFunctions) => {
  const content = {};
  const parentContentPath = '/';
  const transientContext = {};
  const jobSource = {
    type: 'getObjectValueBehavior',
    path: 'id',
    object: {
      type: 'jobReferenceBehavior'
    }
  };
  const jobID = await evaluateSource.evaluateSource(jobSource, content, parentContentPath, transientContext, nativeFunctions);
  const [sortOrderIdentifier] = Object.keys(sortOrder);
  const paths = getInfo(workItemLocations).map(info => info.path);
  const reportsSource = {
    type: 'queryEntityBehavior',
    entityName: 'Report',
    properties: ['appCreated', 'content', 'reportType/name', 'reportNumber'],
    equals: {
      'job/id': jobID
    },
    equalsOneOf: {
      'reportType/identifier': reportTypes
    },
    ifContent: {
      atAnyPaths: paths
    },
    orderBy: [{
      property: 'appCreated',
      ascending: sortOrderIdentifier !== 'descending'
    }]
  };
  const reports = await evaluateSource.evaluateSource(reportsSource, content, parentContentPath, transientContext, nativeFunctions);
  return reports;
};

/**
  * @function evalute - evaluate navsea00932ExportBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const picked = pick(source, ['appendices', 'workItemLocations', 'grouping', 'sortOrder', 'reportTypes']);
  const evaluated = await evaluateSource.evaluateSources(picked, content, parentContentPath, transientContext, nativeFunctions);
  const {
    appendices = {},
    workItemLocations = {},
    grouping = {},
    sortOrder = {},
    reportTypes = []
  } = evaluated;
  const reports = await getReports(workItemLocations, sortOrder, reportTypes, nativeFunctions);

  // special-case appendix 8
  let appendix8Results = {};
  if (appendices.appendix8 !== undefined) {
    reports.forEach(report => {
      const {
        content: reportContentString = '{}'
      } = report;
      const reportContent = JSON.parse(reportContentString);
      const {
        appendix8: {
          system,
          workItemLocation
        } = {}
      } = reportContent;
      const systemOption = system === undefined ? {} : {
        [system.title]: system
      };
      appendix8Results = merge(appendix8Results, {
        system: systemOption,
        workItemLocation
      });
    });
  }
  // and remove from standard processing
  const {
      appendix8: _remove1
    } = appendices,
    processAppendices = _objectWithoutProperties(appendices, _excluded);
  const [groupingIdentifier] = Object.keys(grouping);
  const group1 = {};
  reports.forEach((report, index) => {
    const {
      appCreated: dateKey,
      content: reportContentString = '{}'
    } = report;
    const dateValue = {
      _created: index
    };
    const reportContent = JSON.parse(reportContentString);
    const latestStatus = latestStatusFromContent(reportContent);
    const reportAppendices = Object.keys(processAppendices).filter(appendix => hasContentValue(reportContent[appendix]));
    if (reportAppendices.length > 0) {
      const {
        appendix8 = {}
      } = reportContent;
      const {
        workItemLocation = {}
      } = appendix8;
      const [workItemLocationInfo] = getInfo(workItemLocation);
      if (workItemLocationInfo === undefined) {
        return;
      }
      const {
        path: locationPath,
        title: locationTitle,
        identifier: locationKey
      } = workItemLocationInfo;
      const _ref = getContentValue(locationPath, reportContent) || {},
        {
          system: _remove2
        } = _ref,
        locationValue = _objectWithoutProperties(_ref, _excluded2);
      reportAppendices.forEach(appendixKey => {
        const appendixValue = appendices[appendixKey];
        const groupingMaps = {
          appendixLocation: {
            // appendix, location, date
            key1: appendixKey,
            value1: appendixValue,
            key2: locationKey,
            value2: locationValue,
            key3: dateKey,
            value3: dateValue,
            titleComponents: {
              one: {
                text: appendixValue.fullTitle,
                _created: 1
              },
              two: {
                text: locationTitle,
                _created: 2
              },
              three: {
                date: dateKey,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          },
          locationAppendix: {
            // location, appendix, date
            key1: locationKey,
            value1: locationValue,
            key2: appendixKey,
            value2: appendixValue,
            key3: dateKey,
            value3: dateValue,
            titleComponents: {
              one: {
                text: locationTitle,
                _created: 1
              },
              two: {
                text: appendixValue.fullTitle,
                _created: 2
              },
              three: {
                date: dateKey,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          },
          appendix: {
            // appendix, date, location
            key1: appendixKey,
            value1: appendixValue,
            key2: dateKey,
            value2: dateValue,
            key3: locationKey,
            value3: locationValue,
            titleComponents: {
              one: {
                text: appendixValue.fullTitle,
                _created: 1
              },
              two: {
                date: dateKey,
                _created: 2
              },
              three: {
                text: locationTitle,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          },
          location: {
            // location, date, appendix
            key1: locationKey,
            value1: locationValue,
            key2: dateKey,
            value2: dateValue,
            key3: appendixKey,
            value3: appendixValue,
            titleComponents: {
              one: {
                text: locationTitle,
                _created: 1
              },
              two: {
                date: dateKey,
                _created: 2
              },
              three: {
                text: appendixValue.fullTitle,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          },
          none: {
            // date, appendix, location
            key1: dateKey,
            value1: dateValue,
            key2: appendixKey,
            value2: appendixValue,
            key3: locationKey,
            value3: locationValue,
            titleComponents: {
              one: {
                date: dateKey,
                _created: 1
              },
              two: {
                text: appendixValue.fullTitle,
                _created: 2
              },
              three: {
                text: locationTitle,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          }
        };
        const {
          key1,
          value1,
          key2,
          value2,
          key3,
          value3,
          titleComponents
        } = groupingMaps[groupingIdentifier || 'none'];
        if (group1[key1] === undefined) {
          group1[key1] = _objectSpread(_objectSpread({}, value1), {}, {
            group2: {}
          });
        }
        if (group1[key1].group2[key2] === undefined) {
          group1[key1].group2[key2] = _objectSpread(_objectSpread({}, value2), {}, {
            group3: {}
          });
        }
        const itemContent = _objectSpread(_objectSpread({}, value3), {}, {
          titleComponents
        });
        itemContent[appendixKey] = reportContent[appendixKey];
        group1[key1].group2[key2].group3[key3] = itemContent;
      });
    }
  });
  return {
    group1,
    appendix8: appendix8Results
  };
};
module.exports = {
  evaluate
};